import React from '@root/vendor/react';

const HubspotFormsContext = React.createContext({});

export default HubspotFormsContext;
